/**
 * @file planService.ts
 * @description Service for handling plan-related API calls.
 * Provides functionality for updating plan metadata.
 */

import config from "../config/config";
import { auth } from "../config/firebaseConfig";
import log from "../config/logging";

/**
 * Update the name of an editorial plan.
 * @param planId - ID of the plan to update
 * @param name - New plan name
 */
export const updatePlanName = async (
  planId: string,
  name: string
): Promise<void> => {
  try {
    const token = await auth.currentUser?.getIdToken();
    if (!token) {
      throw new Error("User not authenticated");
    }

    const response = await fetch(`${config.backendUrl}/api/plans/${planId}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message || `Failed to update plan name: ${response.statusText}`
      );
    }

    log.debug("Plan name updated successfully", { planId, name });
  } catch (error) {
    log.error("Error updating plan name", { error, planId });
    throw error;
  }
};
